import React from "react";
import PropTypes from "prop-types";
import * as classes from "./FoodCardSection.module.css";

import FoodCard from "../food-card/FoodCard";

const FoodCardSection = ({ title, menus }) => {
  return menus.length % 2 === 1 ? (
    <section>
      <h2>{title}</h2>
      <section className={classes.grid}>
      {menus && menus.filter((item, index) => {
          return index < menus.length - 1
        }).map((item, index) => {
          return (
            <FoodCard
              key={`menu_${index}`}
              title={item.title}
              content={item.content}
            />
          );
        })}
      </section>
      <section className={classes.odd_number}>
        {menus && menus.filter((item, index) => {
          return index === menus.length - 1
        }).map((item, index) => {
            return (
              <FoodCard
                key={`menu_${index}`}
                title={item.title}
                content={item.content}
              />
            );
          })}
      </section>
    </section>
  ) : (
    <section>
      <h2>{title}</h2>
      <section className={classes.grid}>
        {menus &&
          menus.map((item, index) => {
            return (
              <FoodCard
                key={`menu_${index}`}
                title={item.title}
                content={item.content}
              />
            );
          })}
      </section>
    </section>
  );
};

FoodCardSection.propTypes = {
  title: PropTypes.string.isRequired,
  menus: PropTypes.array.isRequired
};

export default FoodCardSection;
